import { IncomeType } from "shared/types";
import { AssetItem } from "views/applications-id-report/components/SmartRender/AssetItem";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";

export const OfferLetterAssets = ({ income }: { income: CombinedIncome }) => {
  if (income.type !== IncomeType.OfferLetter) return null;

  return (
    <div className="mb-4 space-y-3">
      {income.assets.map((a, aIdx) => (
        <AssetItem
          key={`${income.type}_${a.asset?.url}__${aIdx}`}
          url={a.asset?.url || ""}
          content_type={a.asset?.content_type || ""}
          assetName={a.asset?.filename || "Document"}
        />
      ))}
    </div>
  );
};
